export const toNumber = (value: string | null) => {
  if (value != null) return Number(value);

  return 0;
};
